//================================================================================
// 28Th Oct, 2025 src/components/tenantcomponents/LegalAgreements/PrivacyPolicy.js
//================================================================================
import React from 'react';
import { Typography, Box } from '@mui/material';

const PrivacyPolicy = () => (
  <Box sx={{ maxHeight: '300px', overflow: 'auto', p: 2, border: '1px solid #ccc' }}>
    <Typography variant="h6" gutterBottom>
      PRIVACY POLICY & DATA PROCESSING AGREEMENT
    </Typography>
    
    <Typography variant="body2" paragraph>
      <strong>Effective Date:</strong> {new Date().toLocaleDateString()}
    </Typography>

    <Typography variant="body2" paragraph>
      <strong>1. DATA COLLECTION</strong><br/>
      We collect: Business information, contact details, transaction data, inventory records, 
      and user activity logs for providing pharmacy management services.
    </Typography>

    <Typography variant="body2" paragraph>
      <strong>2. DATA USAGE</strong><br/>
      - Provide and maintain the ERP system<br/>
      - Process transactions and generate reports<br/>
      - Ensure regulatory compliance<br/>
      - Improve system performance and features
    </Typography>

    <Typography variant="body2" paragraph>
      <strong>3. DATA STORAGE & SECURITY</strong><br/>
      - Data encrypted in transit and at rest<br/>
      - Regular security audits and backups<br/>
      - Access controls and authentication<br/>
      - Compliance with data protection regulations
    </Typography>

    <Typography variant="body2" paragraph>
      <strong>4. DATA SHARING</strong><br/>
      We do not sell your data. Limited sharing with:<br/>
      - Payment processors for transaction processing<br/>
      - Regulatory authorities when required by law<br/>
      - Service providers under strict confidentiality
    </Typography>

    <Typography variant="body2" paragraph>
      <strong>5. YOUR RIGHTS</strong><br/>
      - Access and download your data<br/>
      - Request data correction<br/>
      - Request account deletion<br/>
      - Export data upon termination
    </Typography>
    <Typography variant="body2" paragraph>
      <strong>6. BETA TESTING DATA HANDLING</strong><br/>
      During the BETA period, data may be stored on shared infrastructure. 
      MedicERP does not guarantee physical data isolation between tenants at 
      the infrastructure level. Tenants are responsible for not uploading 
      sensitive regulated data (e.g., patient-identifiable information) until 
      a dedicated hosting arrangement is confirmed.
    </Typography>
  </Box>
);

export default PrivacyPolicy;